import { MyOrdersPage } from "src/organisms/MyOrdersView";
import { buildStaticProps } from "src/utils/static-props/app-page-props";

function MyOrders(): JSX.Element {
  return <MyOrdersPage />;
}

export async function getStaticProps() {
  return buildStaticProps({});
}

export default MyOrders;
